import Vue from "vue";
import i18n from "@/i18n/i18n";

const injectParamsToUrl = urlOrObj => {
  let url = i18n.locale;
  if (urlOrObj.constructor.name === "Object") {
    url += urlOrObj.path;
    const replacements = urlOrObj.replace || {};

    const regex = ":([0-9a-zA-Z_-]+)";
    const matches = url.match(new RegExp(regex, "ig"));
    if (matches) {
      matches.map(key => {
        const replacerKey = key.match(new RegExp(regex, "i"))[1];
        const replacerVal = replacements[replacerKey];

        if (!replacerVal) {
          throw new TypeError(
            "Url replacement error: " +
            replacerKey +
            " value not found in replacer parameters!"
          );
        }

        url = url.replace(key, replacerVal);

        return key;
      });
    }
  } else {
    url = i18n.locale + urlOrObj;
  }

  return url;
};

const requestHandler = ({
  method = "GET",
  url,
  params = {},
  body = null,
  headers = null,
  extraOptions = null,
  payload = {}
}) => {
  let options = {};

  options.method = method.toUpperCase();
  options.url = process.env.VUE_APP_BASE_URL + injectParamsToUrl(url);

  if (params) {
    options.params = params;
  }

  if (body) {
    options.data = body;
  }

  if (headers) {
    options.headers = headers;
  }

  if (extraOptions) {
    options = Object.assign(options, extraOptions);
  }

  options.validateStatus = function (status) {
    return status <= 500;
  };

  const promise = Vue.prototype.$http(options);

  promise.finally = cb => {
    if (!(cb instanceof Function)) {
      throw new TypeError(`${url} request finally callback is not a function!`);
    }
    promise.then(cb).catch(cb);
    return promise;
  };

  promise.success = cb => {
    if (!(cb instanceof Function)) {
      throw new TypeError(`${url} request then callback is not a function!`);
    }

    promise.then(response => {
      if (response.status == 200 || response.status == 201) {
        if (response.data && (response.data.error || response.data.errors)) {
          payload.$vs.notify({
            time: 2500,
            title: i18n.messages[i18n.locale].Error,
            text: response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right"
          });
        } else cb(response.data, response.status, response);
      } else {
        payload.$vs.notify({
          time: 2500,
          title: i18n.messages[i18n.locale].Error,
          text: response.data.error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right"
        });
      }
    });
    setTimeout(() => {
      payload.$vs.loading.close(".con-vs-loading");
    }, 100);
    return promise;
  };

  promise.error = cb => {
    if (!(cb instanceof Function)) {
      throw new TypeError(`${url} request catch callback is not a function!`);
    }
    promise.catch(err => {
      if (err.response) {
        cb(err.response.data, err.response.status, err.response);
      } else {
        cb(null, null, err.response);
      }
    });
    setTimeout(() => {
      payload.$vs.loading.close(".con-vs-loading");
    }, 100);
    return promise;
  };

  promise.catch(error => {
    payload.$vs.notify({
      time: 2500,
      title: i18n.messages[i18n.locale].Error,
      text: i18n.messages[i18n.locale][500],
      iconPack: "feather",
      icon: "icon-alert-circle",
      color: "danger",
      position: "top-right"
    });
    setTimeout(() => {
      payload.$vs.loading.close(".con-vs-loading");
    }, 100);

    if (payload.$router) {
      const to = payload.$router.currentRoute.name != 'maintenance' ? payload.$router.currentRoute.fullPath : '';
      payload.$router.push({ path: "/maintenance", query: { to: to } });
    }

    return promise;
  });

  promise.then(response => {
    if (response.status == 403 || response.status == 401) {
      payload.$vs.notify({
        time: 2500,
        title: i18n.messages[i18n.locale].Error,
        text: response.data.error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "top-right"
      });
      setTimeout(() => {
        payload.$vs.loading.close(".con-vs-loading");
      }, 100);
      return Promise.reject("Server error.");
    }
    if (response.data && (response.data.error || response.data.errors)) {
      payload.$vs.notify({
        time: 2500,
        title: i18n.messages[i18n.locale].Error,
        text: response.data.error ? response.data.error : (response.data.errors ? "<ul><li>- " + Object.values(response.data.errors)[0].join('<li>- ') + "</ul>" : ""),
        iconPack: "feather",
        icon: "icon-alert-circle",
        mode: "html",
        color: "danger",
        position: "top-right"
      });
      setTimeout(() => {
        payload.$vs.loading.close(".con-vs-loading");
      }, 100);
    }

    return promise;
  });

  return promise;
};

class Http {
  static get(url, params = null, headers = null, payload = {}) {
    return requestHandler({
      method: "GET",
      url,
      params,
      body: null,
      headers,
      payload
    });
  }

  static post(url, body = null, params = null, headers = null, payload = {}) {
    return requestHandler({
      method: "POST",
      url,
      params,
      body,
      headers,
      payload
    });
  }

  static put(url, body = null, params = null, headers = null, payload = {}) {
    return requestHandler({
      method: "PUT",
      url,
      params,
      body,
      headers,
      payload
    });
  }

  static patch(url, body = null, params = null, headers = null, payload = {}) {
    return requestHandler({
      method: "PATCH",
      url,
      params,
      body,
      headers,
      payload
    });
  }

  static delete(url, body = null, params = null, headers = null, payload = {}) {
    return requestHandler({
      method: "DELETE",
      url,
      params,
      body,
      headers,
      payload
    });
  }
}

export default Http;
